import PayTraceIcon from './PayTraceIcon'

export default PayTraceIcon
